import { useContext } from "react";
import { Context } from "../../../context/Context";
import { SectionHeader } from "../../ui";
import AccountantView from "./AccountantView";
import { accountantText } from "./accountantText";

// The Billing page of the accountant (fa), who holds this workspace and no billing administration.
// Administrators open the same view from the "Accounting" section of BillingAdmin.
const AccountantPage = () => {
  const { lang } = useContext(Context) || {};
  const language = lang === "en" ? "en" : "ar";
  const text = accountantText(language);
  return (
    <main className="billing-admin billing-admin-v141" dir={language === "ar" ? "rtl" : "ltr"}>
      <SectionHeader title={text.pageTitle} description={text.pageDescription} />
      <AccountantView lang={language} />
    </main>
  );
};

export default AccountantPage;
